export default __webpack_public_path__ + "static/img_blog.png";